
import Videos from "../Components/Common/Videos";
import Ads from "../Components/FirstComponents/Ads";
import { useEffect, useState } from "react";
import ListboxSelect from "../Utils/ListboxSelect";
import Banner from "../Utils/Banner";
import { motion } from "framer-motion";

function Podcasts() {
  const [contents, setContents] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    id: 0,
    name: "All",
  });
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: 0,
    name: "All",
  });

  // Animation variants
  const pageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const filterVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.5,
        delay: 0.2,
        ease: "easeOut"
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.4,
        ease: "easeOut"
      }
    }
  };

  useEffect(() => {
    const callContents = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL +
            "/contents?content_category_id=3",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        setContents(data);
        console.log(contents);
        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callContents();
  }, []);

  useEffect(() => {
    const callLanguages = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/languages",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        const all = { id: 0, name: "All" };
        data.unshift(all);
        setLanguages(data);
        console.log(languages);
        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callLanguages();
    const callSubCategories = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/content-subcategories",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        const all = { id: 0, name: "All" };
        data.unshift(all);
        setSubCategories(data);

        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callSubCategories();
  }, []);

  return (
    <>
      <motion.div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
        variants={pageVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="mx-auto ">
          <Banner
            title="Podcasts Videos"
            imageUrl="/assets/Second_Banner.png"
          />

          <motion.span 
            className="flex flex-col sm:flex-row justify-end gap-2 m-4 sm:m-10"
            variants={filterVariants}
            initial="hidden"
            animate="visible"
          >
            <ListboxSelect
              label={"All Languages"}
              items={languages}
              onSelect={setSelectedLanguage}
            />
            <ListboxSelect
              label="All Sub Categories"
              items={subCategories}
              onSelect={setSelectedSubCategory}
            />
          </motion.span>
          <motion.div 
            className="mx-auto mb-10 ml-4 md:ml-6 md:mr-6 lg:mr-16 lg:ml-14 xl:ml-16 xl:mr-14"
            variants={contentVariants}
            initial="hidden"
            animate="visible"
          >
            <Videos
              contents={contents}
              subCategory={selectedSubCategory}
              language={selectedLanguage}
              buttonText={"Watch Now"}
            />
            <Ads />
            {/* <Subscribe /> */}
          </motion.div>
        </div>
      </motion.div>
    </>
  );
}

export default Podcasts;
